// Reverse-geocode lat/lng to a US address via Nominatim (free, no API key).
// Browsers send Referer automatically (Nominatim's usage policy); User-Agent can't be set from fetch.
export async function reverseGeocode(lat, lng) {
  const url = `https://nominatim.openstreetmap.org/reverse?format=jsonv2&addressdetails=1&lat=${lat}&lon=${lng}`;
  const res = await fetch(url, { headers: { Accept: "application/json" } });
  if (!res.ok) throw new Error("reverse geocode failed");
  const data = await res.json();
  const a = data.address || {};
  const street = [a.house_number, a.road].filter(Boolean).join(" ");
  const city = a.city || a.town || a.village || a.hamlet || a.county || "";
  const full = [street, city, [a.state, a.postcode].filter(Boolean).join(" ")].filter(Boolean).join(", ");
  return {
    full: full || data.display_name || "",
    street,
    city,
    state: a.state || "",
    zip: a.postcode || "",
    country_code: a.country_code || "",
  };
}
